<div app-landing-page-section-container class="items-center">
    <div class="mat-headline-6 lg:w-[900px] text-center pb-4" translate>
        LandingPagePartnersHeadline
    </div>
    <div
        class="grid gap-5 sm:gap-20 grid-cols-1 sm:grid-cols-2 md:w-[500px] mt-4"
    >
        <img
            class="h-12 mx-auto"
            src="/assets/images/landing-page/collaborations/logo-imt.svg"
            alt="IMT logo"
        />
        <img
            class="h-12 mx-auto"
            src="/assets/images/landing-page/collaborations/logo-nexxiot.svg"
            alt="Nexxiot logo"
        />
    </div>
</div>
